<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
import { color } from "@/util/util";
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        // this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      console.log("五类青少年数据", data)
      let _this = this;
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
      this.chart = echarts.init(this.$el, "macarons");
      let setOptionStyle = {
        // dataZoom: {
        //     start: 80,
        //     type: "inside"
        // },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: 'rgba(255,255,255,1)'
        },
        legend: {
          data: [],
          textStyle: {
            color: "#409EFF",
          },
          //   right: "5%",
          top: "2%",
        },
        dataset: {
          source: [
            {
              product: "茶园街道",
              "闲散青少年": 43.3,
              "有或(严重)不良行为青少年": 85.8,
              "流浪乞讨青少年": 93.7,
              "服刑在教人员未成年子女": 85,
              "农村留守儿童": 36,
            },
            {
              product: "王庄街道",
              闲散青少年: 83.1,
              "有或(严重)不良行为青少年": 73.4,
              流浪乞讨青少年: 55.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "象园街道",
              闲散青少年: 86.4,
              "有或(严重)不良行为青少年": 65.2,
              流浪乞讨青少年: 82.5,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "鼓山镇",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "新店镇",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "岳峰镇",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "官溪镇",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "寿山乡",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
            {
              product: "日溪乡",
              闲散青少年: 72.4,
              "有或(严重)不良行为青少年": 53.9,
              流浪乞讨青少年: 39.1,
              服刑在教人员未成年子女: 85,
              农村留守儿童: 36,
            },
          ],
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            // rotate: 45,
            interval: 0,
            color: _this.isbig ? "#AABEFF" : "#333",
          },
        },
        yAxis: {
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "#333",
          },
          splitArea: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          // { type: "bar", itemStyle: { color: "#70d402" } },
          // { type: "bar", itemStyle: { color: "#48d3b7" } },
          // { type: "bar", itemStyle: { color: "#b920e8" } },
          // { type: "bar", itemStyle: { color: "#6038ff" } },
          // { type: "bar", itemStyle: { color: "#12a6ff" } },
        ],
        // #058dfa
      }
      setOptionStyle.dataset.source = [];
      for (var index in data.dataTypeList) {
        if (data.dataTypeList[index] != undefined) {
          setOptionStyle.legend.data.unshift(data.dataTypeList[index]);
          let seriesList = { type: "bar", itemStyle: { color: color[index]} }
          setOptionStyle.series.push(seriesList);
        }
      }
      for (var key in data.temp) {
        let sourceList = {
          product: data.temp[key].name,
        };
        for (var typeIndex in data.dataTypeList) {
          if (data.temp[key].data[typeIndex] == undefined) {
            sourceList[data.dataTypeList[typeIndex]] = 0;
            continue;
          }
          sourceList[data.dataTypeList[typeIndex]] = data.temp[key].data[typeIndex];
        }
        setOptionStyle.dataset.source.push(sourceList)
      }
      // console.log(setOptionStyle.legend.data);
      // console.log(setOptionStyle.dataset.source);
      this.chart.setOption(setOptionStyle);
    },
    loadColorData() {
      //颜色字符串
      let colorData = "";
      //字符串的每一字符的范围
      var randomArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
      //产生一个六位的字符串
      for (var i = 0; i < 6; i++) {
        //15是范围上限，0是范围下限，两个函数保证产生出来的随机数是整数
        colorData += randomArr[Math.ceil(Math.random() * (15 - 0) + 0)];
      }
      return "#" + colorData;
    }
  },
};
</script>
